<template>
  <div>
    <validation-observer ref="tagObserver">
      <b-sidebar
        id="addacldevice"
        ref="deviceForm"
        bg-variant="white"
        right
        backdrop
        shadow
        class="sidebar-form"
        @hidden="sidebarToggle"
      >
        <h3 class="form-title">
          {{ id ? "Edit" : "Add" }} ACL Device
        </h3>
        <div class="line user-underline" />
        <b-form-group
          label="ID"
          label-for="acldeviceid"
          class="required-form-filed"
        >
          <validation-provider
            #default="{ errors }"
            name="ID"
            rules="required|max:50"
          >
            <b-form-input
              id="acldeviceid"
              v-model="aclDeviceId"
              :state="errors.length > 0 ? false : null"
              placeholder="Enter ID"
              :readonly="id"
            />
            <small
              v-if="errors[0]"
              class="text-danger"
            >{{ errors[0] }}</small>
            <small
              v-else
              class="text-danger"
            >{{ error }}</small>
          </validation-provider>
        </b-form-group>
        <!-- Tag color -->
        <b-form-group
          label="Name"
          label-for="name"
          class="required-form-filed"
        >
          <validation-provider
            #default="{ errors }"
            name="Name"
            mode="passive"
            rules="required|max:255"
          >
            <b-form-input
              id="name"
              v-model="name"
              type="text"
              name="name"
              placeholder="Enter name"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <!--TagColor End-->

        <b-form-group
          label="Office Access Device"
          class="d-flex justify-content-between"
          label-for="is_device_access"
        >
          <b-form-checkbox
            id="is_device_access"
            v-model="is_device_access"
            class="custom-control-success d-flex justify-content-between"
            name="check-button"
            switch
          >
            <span class="switch-icon-right">
              <feather-icon icon="XIcon" />
            </span>
            <span class="switch-icon-left">
              <feather-icon icon="CheckIcon" />
            </span>
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          label="Attendance Tracking"
          class="d-flex justify-content-between"
          label-for="is_attendance_tracking"
        >
          <b-form-checkbox
            id="is_attendance_tracking"
            v-model="is_attendance_tracking"
            class="custom-control-success d-flex justify-content-between"
            name="check-button"
            switch
          >
            <span class="switch-icon-right">
              <feather-icon icon="XIcon" />
            </span>
            <span class="switch-icon-left">
              <feather-icon icon="CheckIcon" />
            </span>
          </b-form-checkbox>
        </b-form-group>

        <template #footer>
          <div class="form-button d-flex my-2">
            <button
              class="btn side-bar-btn"
              :disabled="btnLoader"
              @click.prevent="validationForm"
            >
              <b-spinner
                v-if="btnLoader"
                small
                class="spinner"
              />
              {{ id ? "Update" : "Save" }}
            </button>
            <button
              class="btn side-bar-btn"
              @click="$root.$emit('bv::toggle::collapse', 'addacldevice')"
            >
              Cancel
            </button>
          </div>
        </template>
      </b-sidebar>
    </validation-observer>
  </div>
</template>

<script>
import AclDeviceForm from "../../../mixin/masterSetting/AclDevice/form.js"
import {
  BFormGroup,
  BFormInput,
  BSidebar,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'AclDeviceTableFrom',
  components: {
    BFormGroup,
    BFormInput,
    BSidebar,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [AclDeviceForm],
}
</script>

<style lang="scss">
.custom-radio {
  .custom-control-label {
    margin-top: 0 !important;
  }
}
</style>
